/**
 * useLabelBatch — global zustand store for the "Add to label batch" feature.
 *
 * Lets any PrintLabelButton (or other UI surface) push an item into a
 * shared tray, then a floating widget prints them all in a single
 * multi-page PDF via /api/qr-labels/render.
 *
 * Persisted to localStorage so the tray survives hard refresh + cross-tab.
 *
 * Items: { entity: 'product'|'asset', id, name }
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useLabelBatch = create(
  persist(
    (set, get) => ({
      items: [],

      add: (item) => {
        if (!item?.id || !item?.entity) return;
        const exists = get().items.find(x => x.id === item.id && x.entity === item.entity);
        if (exists) return;
        set({ items: [...get().items, { ...item }] });
      },

      remove: (id) => set({ items: get().items.filter(x => x.id !== id) }),

      clear: () => set({ items: [] }),

      count: () => get().items.length,
    }),
    {
      name: 'fwm-label-batch',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
